import { useEffect } from "react";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8009";

const LinkedInCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (!code) {
      window.opener?.postMessage(
        { type: "LINKEDIN_ERROR", error: "No authorization code" },
        window.location.origin,
      );
      window.close();
      return;
    }

    const loginWithLinkedIn = async () => {
      try {
        const parentId = process.env.REACT_APP_SUPERADMIN_ID;

        const res = await fetch(`${API_BASE_URL}/api/v1/auth/linkedin`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code, parentId }),
        });

        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.error || "LinkedIn login failed");
        }

        const data = await res.json();

        // 🔥 SEND DATA TO PARENT WINDOW
        window.opener?.postMessage(
          { type: "LINKEDIN_SUCCESS", payload: data },
          window.location.origin,
        );

        // ✅ CLOSE POPUP
        window.close();
      } catch (err) {
        window.opener?.postMessage(
          { type: "LINKEDIN_ERROR", error: err.message },
          window.location.origin,
        );
        window.close();
      }
    };

    loginWithLinkedIn();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-blue-100">
      <div className="text-center bg-white p-8 rounded-xl shadow-lg max-w-md">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mx-auto mb-4"></div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          Completing LinkedIn Login
        </h2>
        <p className="text-gray-600">Please wait a moment...</p>
      </div>
    </div>
  );
};

export default LinkedInCallback;
